import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AppProvider from 'hooks/useAppProvider';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleTagManager from 'googleTools/GoogleTagManager';
import { SnackbarProvider } from 'notistack';

import store from 'store';
import theme from 'theme';
import Router from './router';
import { ErrorProvider } from './context/ErrorContext';

function App() {
  const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY ?? '';
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

  return (
    <GoogleReCaptchaProvider reCaptchaKey={captchaKey}>
      <SnackbarProvider dense maxSnack={3} style={{ fontFamily: 'Nunito' }}>
        <GoogleOAuthProvider clientId={googleClientId}>
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <AppProvider>
                <ErrorProvider>
                  <BrowserRouter basename="/auth">
                    <>
                      <Router />
                      <GoogleTagManager />
                    </>
                  </BrowserRouter>
                </ErrorProvider>
              </AppProvider>
            </ThemeProvider>
          </Provider>
        </GoogleOAuthProvider>
      </SnackbarProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
